import { useEffect } from 'react';
import type { UserSession } from './types';

export function useInitialLoad(session: UserSession, loadNotifications: () => Promise<void>) {
  const { user } = session;

  // Initial load
  useEffect(() => {
    if (user?.id) {
      loadNotifications();
    }
  }, [user?.id, loadNotifications]);
}
